Ext.define('SA.EditPanelDisabledSectionController', {
    constructor({itemFactory, sectionId = null, message}) {
        this.itemFactory = itemFactory;
        this.sectionId = sectionId;
        this.view = Ext.widget({xtype: 'edit-panel-disabled-section', message});
    },

    eachItem(callback) {
        this.view.eachItem(callback);
    },

    getView() {
        return this.view;
    },

    hasSectionId(sectionId) {
        return this.sectionId === sectionId;
    },

    setIds(ids) {
        var items = ids.map(id => this.view.findItem(id) ?? this.itemFactory(id));

        this.view.syncItems(items);
        this.view.setVisible(items.length > 0);
    }
});